"use strict";

var e = require("@react-pdf-viewer/core"),
  t = require("@react-pdf-viewer/selection-mode"),
  r = require("react"),
  n = require("@react-pdf-viewer/full-screen"),
  o = require("@react-pdf-viewer/get-file"),
  a = require("@react-pdf-viewer/open"),
  l = require("@react-pdf-viewer/page-navigation"),
  i = require("@react-pdf-viewer/print"),
  c = require("@react-pdf-viewer/properties"),
  m = require("@react-pdf-viewer/rotate"),
  u = require("@react-pdf-viewer/scroll-mode"),
  s = require("@react-pdf-viewer/search"),
  d = require("@react-pdf-viewer/theme"),
  p = require("@react-pdf-viewer/zoom");
function v(e) {
  var t = Object.create(null);
  return e && Object.keys(e).forEach(function (r) {
    if ("default" !== r) {
      var n = Object.getOwnPropertyDescriptor(e, r);
      Object.defineProperty(t, r, n.get ? n : {
        enumerable: !0,
        get: function get() {
          return e[r];
        }
      });
    }
  }), t.default = e, Object.freeze(t);
}
var _ = v(r),
  E = function E() {
    return _.createElement(e.Icon, {
      size: 16
    }, _.createElement("path", {
      d: "M12,0.5c1.381,0,2.5,1.119,2.5,2.5S13.381,5.5,12,5.5S9.5,4.381,9.5,3S10.619,0.5,12,0.5z\n            M12,9.5\n            c1.381,0,2.5,1.119,2.5,2.5s-1.119,2.5-2.5,2.5S9.5,13.381,9.5,12S10.619,9.5,12,9.5z\n            M12,18.5c1.381,0,2.5,1.119,2.5,2.5\n            s-1.119,2.5-2.5,2.5S9.5,22.381,9.5,21S10.619,18.5,12,18.5z"
    }));
  },
  g = {
    left: 0,
    top: 8
  },
  P = function P(r) {
    var n = r.toolbarSlot,
      o = _.useContext(e.LocalizationContext).l10n,
      a = _.useContext(e.ThemeContext).direction === e.TextDirection.RightToLeft ? e.Position.BottomLeft : e.Position.BottomRight,
      l = n.DownloadMenuItem,
      i = n.EnterFullScreenMenuItem,
      c = n.GoToFirstPageMenuItem,
      m = n.GoToLastPageMenuItem,
      u = n.GoToNextPageMenuItem,
      s = n.GoToPreviousPageMenuItem,
      d = n.OpenMenuItem,
      p = n.PrintMenuItem,
      v = n.RotateBackwardMenuItem,
      P = n.RotateForwardMenuItem,
      M = n.ShowPropertiesMenuItem,
      h = n.SwitchScrollModeMenuItem,
      f = n.SwitchSelectionModeMenuItem,
      S = n.SwitchViewModeMenuItem,
      I = n.SwitchThemeMenuItem;
    return _.createElement(e.Popover, {
      ariaControlsSuffix: "toolbar-more-actions",
      ariaHasPopup: "menu",
      position: a,
      target: function target(t, r) {
        var n = o && o.toolbar ? o.toolbar.moreActions : "More actions";
        return _.createElement(e.Tooltip, {
          ariaControlsSuffix: "toolbar-more-actions",
          position: a,
          target: _.createElement(e.MinimalButton, {
            ariaLabel: n,
            isSelected: r,
            testId: "toolbar__more-actions-popover-target",
            onClick: t
          }, _.createElement(E, null)),
          content: function content() {
            return n;
          },
          offset: g
        });
      },
      content: function content(r) {
        return _.createElement(e.Menu, null, _.createElement("div", {
          className: "rpv-core__display--block rpv-core__display--hidden-medium"
        }, _.createElement(I, {
          onClick: r
        })), _.createElement("div", {
          className: "rpv-core__display--block rpv-core__display--hidden-medium"
        }, _.createElement(i, {
          onClick: r
        })), _.createElement("div", {
          className: "rpv-core__display--block rpv-core__display--hidden-medium"
        }, _.createElement(d, null)), _.createElement("div", {
          className: "rpv-core__display--block rpv-core__display--hidden-medium"
        }, _.createElement(p, {
          onClick: r
        })), _.createElement("div", {
          className: "rpv-core__display--block rpv-core__display--hidden-medium"
        }, _.createElement(l, {
          onClick: r
        })), _.createElement("div", {
          className: "rpv-core__display--block rpv-core__display--hidden-medium"
        }, _.createElement(e.MenuDivider, null)), _.createElement(c, {
          onClick: r
        }), _.createElement("div", {
          className: "rpv-core__display--block rpv-core__display--hidden-medium"
        }, _.createElement(s, {
          onClick: r
        })), _.createElement("div", {
          className: "rpv-core__display--block rpv-core__display--hidden-medium"
        }, _.createElement(u, {
          onClick: r
        })), _.createElement(m, {
          onClick: r
        }), _.createElement(e.MenuDivider, null), _.createElement(P, {
          onClick: r
        }), _.createElement(v, {
          onClick: r
        }), _.createElement(e.MenuDivider, null), _.createElement(f, {
          mode: t.SelectionMode.Text,
          onClick: r
        }), _.createElement(f, {
          mode: t.SelectionMode.Hand,
          onClick: r
        }), _.createElement(e.MenuDivider, null), _.createElement(h, {
          mode: e.ScrollMode.Page,
          onClick: r
        }), _.createElement(h, {
          mode: e.ScrollMode.Vertical,
          onClick: r
        }), _.createElement(h, {
          mode: e.ScrollMode.Horizontal,
          onClick: r
        }), _.createElement(h, {
          mode: e.ScrollMode.Wrapped,
          onClick: r
        }), _.createElement(e.MenuDivider, null), _.createElement("div", {
          className: "rpv-core__display--hidden rpv-core__display--block-small"
        }, _.createElement(S, {
          mode: e.ViewMode.SinglePage,
          onClick: r
        })), _.createElement("div", {
          className: "rpv-core__display--hidden rpv-core__display--block-small"
        }, _.createElement(S, {
          mode: e.ViewMode.DualPage,
          onClick: r
        })), _.createElement("div", {
          className: "rpv-core__display--hidden rpv-core__display--block-small"
        }, _.createElement(S, {
          mode: e.ViewMode.DualPageWithCover,
          onClick: r
        })), _.createElement("div", {
          className: "rpv-core__display--hidden rpv-core__display--block-small"
        }, _.createElement(e.MenuDivider, null)), _.createElement(M, {
          onClick: r
        }));
      },
      offset: g,
      closeOnClickOutside: !0,
      closeOnEscape: !0
    });
  },
  _M = function M() {
    return _M = Object.assign || function (e) {
      for (var t, r = 1, n = arguments.length; r < n; r++) for (var o in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
      return e;
    }, _M.apply(this, arguments);
  },
  h = function h(t) {
    return function (r) {
      var n = _.useMemo(function () {
          return t(r);
        }, []),
        o = _.useContext(e.ThemeContext).direction === e.TextDirection.RightToLeft,
        a = n.CurrentPageInput,
        l = n.Download,
        i = n.EnterFullScreen,
        c = n.GoToNextPage,
        m = n.GoToPreviousPage,
        u = n.NumberOfPages,
        s = n.Open,
        d = n.Print,
        p = n.ShowSearchPopover,
        v = n.SwitchTheme,
        E = n.Zoom,
        g = n.ZoomIn,
        M = n.ZoomOut;
      return _.createElement("div", {
        "data-testid": "toolbar",
        className: e.classNames({
          "rpv-toolbar": !0,
          "rpv-toolbar--rtl": o
        }),
        role: "toolbar",
        "aria-orientation": "horizontal"
      }, _.createElement("div", {
        className: "rpv-toolbar__left"
      }, _.createElement("div", {
        className: "rpv-toolbar__item"
      }, _.createElement(p, null)), _.createElement("div", {
        className: "rpv-core__display--hidden rpv-core__display--block-small"
      }, _.createElement("div", {
        className: "rpv-toolbar__item"
      }, _.createElement(m, null))), _.createElement("div", {
        className: "rpv-toolbar__item"
      }, _.createElement(a, null), _.createElement("span", {
        className: "rpv-toolbar__label"
      }, _.createElement(u, null))), _.createElement("div", {
        className: "rpv-core__display--hidden rpv-core__display--block-small"
      }, _.createElement("div", {
        className: "rpv-toolbar__item"
      }, _.createElement(c, null)))), _.createElement("div", {
        className: "rpv-toolbar__center"
      }, _.createElement("div", {
        className: "rpv-toolbar__item"
      }, _.createElement(M, null)), _.createElement("div", {
        className: "rpv-core__display--hidden rpv-core__display--block-small"
      }, _.createElement("div", {
        className: "rpv-toolbar__item"
      }, _.createElement(E, null))), _.createElement("div", {
        className: "rpv-toolbar__item"
      }, _.createElement(g, null))), _.createElement("div", {
        className: "rpv-toolbar__right"
      }, _.createElement("div", {
        className: "rpv-core__display--hidden rpv-core__display--block-medium"
      }, _.createElement("div", {
        className: "rpv-toolbar__item"
      }, _.createElement(v, null))), _.createElement("div", {
        className: "rpv-core__display--hidden rpv-core__display--block-medium"
      }, _.createElement("div", {
        className: "rpv-toolbar__item"
      }, _.createElement(i, null))), _.createElement("div", {
        className: "rpv-core__display--hidden rpv-core__display--block-medium"
      }, _.createElement("div", {
        className: "rpv-toolbar__item"
      }, _.createElement(s, null))), _.createElement("div", {
        className: "rpv-core__display--hidden rpv-core__display--block-medium"
      }, _.createElement("div", {
        className: "rpv-toolbar__item"
      }, _.createElement(l, null))), _.createElement("div", {
        className: "rpv-core__display--hidden rpv-core__display--block-medium"
      }, _.createElement("div", {
        className: "rpv-toolbar__item"
      }, _.createElement(d, null))), _.createElement("div", {
        className: "rpv-toolbar__item"
      }, _.createElement(P, {
        toolbarSlot: n
      }))));
    };
  },
  f = function f(e) {
    var t = e.NumberOfPages;
    return Object.assign({}, e, {
      NumberOfPages: function NumberOfPages() {
        return _.createElement(_.Fragment, null, "/ ", _.createElement(t, null));
      }
    });
  },
  S = function S(e) {
    return h(f)(e);
  },
  I = function I(e) {
    var t = e.children,
      r = e.slot;
    return (t || S)(r);
  };
exports.MoreActionsPopover = P, exports.MoreIcon = E, exports.toolbarPlugin = function (e) {
  var r = n.fullScreenPlugin(e ? e.fullScreenPlugin : {}),
    v = o.getFilePlugin(e ? e.getFilePlugin : {}),
    E = a.openPlugin(e ? e.openPlugin : {}),
    g = l.pageNavigationPlugin(e ? e.pageNavigationPlugin : {}),
    P = i.printPlugin(e ? e.printPlugin : {}),
    f = c.propertiesPlugin(),
    S = m.rotatePlugin(),
    b = u.scrollModePlugin(),
    w = s.searchPlugin(e ? e.searchPlugin : {}),
    y = t.selectionModePlugin(e ? e.selectionModePlugin : {}),
    N = d.themePlugin(),
    k = p.zoomPlugin(e ? e.zoomPlugin : {}),
    C = [r, v, E, g, P, f, S, b, w, y, N, k],
    T = _.useCallback(function (e) {
      var t = r.EnterFullScreen,
        n = r.EnterFullScreenMenuItem,
        o = v.Download,
        a = v.DownloadMenuItem,
        l = E.Open,
        i = E.OpenMenuItem,
        c = g.CurrentPageInput,
        m = g.CurrentPageLabel,
        u = g.GoToFirstPage,
        s = g.GoToFirstPageMenuItem,
        d = g.GoToLastPage,
        p = g.GoToLastPageMenuItem,
        h = g.GoToNextPage,
        C = g.GoToNextPageMenuItem,
        T = g.GoToPreviousPage,
        O = g.GoToPreviousPageMenuItem,
        L = g.NumberOfPages,
        x = P.Print,
        G = P.PrintMenuItem,
        D = f.ShowProperties,
        F = f.ShowPropertiesMenuItem,
        R = S.Rotate,
        V = S.RotateBackwardMenuItem,
        q = S.RotateForwardMenuItem,
        Z = b.SwitchScrollMode,
        z = b.SwitchScrollModeMenuItem,
        j = b.SwitchViewMode,
        B = b.SwitchViewModeMenuItem,
        A = w.Search,
        H = w.ShowSearchPopover,
        W = y.SwitchSelectionMode,
        J = y.SwitchSelectionModeMenuItem,
        K = N.SwitchTheme,
        Q = N.SwitchThemeMenuItem,
        U = k.CurrentScale,
        X = k.Zoom,
        Y = k.ZoomIn,
        $ = k.ZoomInMenuItem,
        ee = k.ZoomOut,
        te = k.ZoomOutMenuItem;
      return _.createElement(I, _M({}, e, {
        slot: {
          CurrentPageInput: c,
          CurrentPageLabel: m,
          CurrentScale: U,
          Download: o,
          DownloadMenuItem: a,
          EnterFullScreen: t,
          EnterFullScreenMenuItem: n,
          GoToFirstPage: u,
          GoToFirstPageMenuItem: s,
          GoToLastPage: d,
          GoToLastPageMenuItem: p,
          GoToNextPage: h,
          GoToNextPageMenuItem: C,
          GoToPreviousPage: T,
          GoToPreviousPageMenuItem: O,
          NumberOfPages: L,
          Open: l,
          OpenMenuItem: i,
          Print: x,
          PrintMenuItem: G,
          Rotate: R,
          RotateBackwardMenuItem: V,
          RotateForwardMenuItem: q,
          Search: A,
          ShowProperties: D,
          ShowPropertiesMenuItem: F,
          ShowSearchPopover: H,
          SwitchScrollMode: Z,
          SwitchScrollModeMenuItem: z,
          SwitchSelectionMode: W,
          SwitchSelectionModeMenuItem: J,
          SwitchViewMode: j,
          SwitchViewModeMenuItem: B,
          SwitchTheme: K,
          SwitchThemeMenuItem: Q,
          Zoom: X,
          ZoomIn: Y,
          ZoomInMenuItem: $,
          ZoomOut: ee,
          ZoomOutMenuItem: te
        }
      }));
    }, []);
  return {
    fullScreenPluginInstance: r,
    getFilePluginInstance: v,
    openPluginInstance: E,
    pageNavigationPluginInstance: g,
    printPluginInstance: P,
    propertiesPluginInstance: f,
    rotatePluginInstance: S,
    scrollModePluginInstance: b,
    searchPluginInstance: w,
    selectionModePluginInstance: y,
    themePluginInstance: N,
    zoomPluginInstance: k,
    install: function install(e) {
      C.forEach(function (t) {
        t.install && t.install(e);
      });
    },
    renderPageLayer: function renderPageLayer(e) {
      return _.createElement(_.Fragment, null, C.map(function (t, r) {
        return t.renderPageLayer ? _.createElement(_.Fragment, {
          key: r
        }, t.renderPageLayer(e)) : _.createElement(_.Fragment, {
          key: r
        });
      }));
    },
    renderViewer: function renderViewer(e) {
      var t = e.slot;
      return C.forEach(function (r) {
        r.renderViewer && (t = r.renderViewer(_M(_M({}, e), {
          slot: t
        })));
      }), t;
    },
    uninstall: function uninstall(e) {
      C.forEach(function (t) {
        t.uninstall && t.uninstall(e);
      });
    },
    onDocumentLoad: function onDocumentLoad(e) {
      C.forEach(function (t) {
        t.onDocumentLoad && t.onDocumentLoad(e);
      });
    },
    onAnnotationLayerRender: function onAnnotationLayerRender(e) {
      C.forEach(function (t) {
        t.onAnnotationLayerRender && t.onAnnotationLayerRender(e);
      });
    },
    onTextLayerRender: function onTextLayerRender(e) {
      C.forEach(function (t) {
        t.onTextLayerRender && t.onTextLayerRender(e);
      });
    },
    onViewerStateChange: function onViewerStateChange(e) {
      var t = e;
      return C.forEach(function (e) {
        e.onViewerStateChange && (t = e.onViewerStateChange(t));
      }), t;
    },
    renderDefaultToolbar: h,
    Toolbar: T
  };
};